export const actions = {
  INPUT_VALID: 'VALIDATION::INPUT_VALID',
  INPUT_INVALID: 'VALIDATION::INPUT_INVALID',
};

export function inputValid(inputHandle) {
  return {
    type: actions.INPUT_VALID,
    payload: {
      inputHandle,
    },
  };
}

export function inputInvalid(inputHandle, error) {
  return {
    type: actions.INPUT_INVALID,
    payload: {
      inputHandle,
      error,
    },
  };
}
